<template>
  <div>
    <b-modal header-bg-variant="primary" header-text-variant="white" v-if="typeof workers.current != 'undefined'" size="xl" id="modal-workers" centered ok-disabled
             title="Сотрудник" cancel-title-html="Закрыть" button-size="sm">
      <b-input hidden v-model="workers.current.id"></b-input>

      <div class="row">
        <div class="col-md-3">
          <h6>Сотрудник</h6>

          <div class="mb-3">
            <b-input size="sm" v-model="workers.current.employee_number" placeholder="Табельный номер"></b-input>
            <small class="form-text text-muted">Табельный номер</small>
          </div>

          <div class="mb-3">
            <b-input size="sm" v-model="workers.current.last_name" placeholder="Фамилия"></b-input>
            <small class="form-text text-muted">Фамилия *</small>
          </div>

          <div class="mb-3">
            <b-input size="sm" v-model="workers.current.first_name" placeholder="Имя"></b-input>
            <small class="form-text text-muted">Имя *</small>
          </div>

          <div class="mb-3">
            <b-input size="sm" v-model="workers.current.middle_name" placeholder="Отчество"></b-input>
            <small class="form-text text-muted">Отчество</small>
          </div>

          <div class="mb-3">
            <b-input size="sm" v-model="workers.current.iin" placeholder="ИИН"></b-input>
            <small class="form-text text-muted">ИИН</small>
          </div>

          <div class="mb-3">
            <b-input type="date" size="sm" v-model="workers.current.birthday"
                     placeholder="Дата рождения"></b-input>
            <small class="form-text text-muted">Дата рождения</small>
          </div>

          <div class="mb-3">
            <Enums :type="'enum'" :name="'gender'" v-model="workers.current.gender"></Enums>
            <small class="form-text text-muted">Пол</small>
          </div>

          <div class="mb-3">
            <b-input type="text" size="sm" v-model="workers.current.workerfunction"
                     placeholder="Должность"></b-input>
            <small class="form-text text-muted">Должность</small>
          </div>


        </div>
        <div class="col-md-3">
          <h6>Параметры</h6>

          <div class="mb-3">
            <Enums :type="'enum'" :name="'invalid_group'" v-model="workers.current.invalid_group"></Enums>
            <small class="form-text text-muted">Инвалидность</small>
          </div>

          <b-form-checkbox size="sm" v-model="workers.current.citizen" value="1" unchecked-value="0">Гражданин РК
          </b-form-checkbox>

          <b-form-checkbox  size="sm" v-model="workers.current.residence_permit" value="1" unchecked-value="0" :disabled="disabled.residence_permit">Вид на жительство
          </b-form-checkbox>

          <b-form-checkbox  size="sm" v-model="workers.current.foreigner_resident" value="1" unchecked-value="0" :disabled="disabled.foreigner_resident">Иностранец-резидент согласно ст.217 НК РК
          </b-form-checkbox>

          <b-form-checkbox v-show="false" size="sm" v-model="workers.current.resident" value="1" unchecked-value="0">
            Резидент
          </b-form-checkbox>

          <b-form-checkbox  size="sm" v-model="workers.current.eaes_member" value="1" unchecked-value="0" :disabled="disabled.eaes_member">
            Член ЕАЭС
          </b-form-checkbox>

          <b-form-checkbox  size="sm" v-model="workers.current.remote_worker" value="1" unchecked-value="0" :disabled="disabled.remote_worker">
            Нерезидент дистанционник
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.pensioner" value="1" unchecked-value="0">
            Пенсионер по возрасту
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.pensioner_year" value="1" unchecked-value="0">
            Пенсионер по выслуге лет
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.warrior" value="1" unchecked-value="0">
            Ветеран боевых действий
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.chernobyl" value="1" unchecked-value="0">
            Ликвидатор ПА ЧАЭС
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.harmful_working_conditions" value="1" unchecked-value="0">
            Вредные условия труда (Расчет ОППВ)
          </b-form-checkbox>


          <hr>
          <b-form-checkbox size="sm" v-model="workers.current.main_work" value="1" unchecked-value="0">
            Основное место работы
          </b-form-checkbox>

          <b-form-checkbox v-show="false" size="sm" v-model="workers.current.civil_contract" value="1" unchecked-value="0">
            По договору ГПХ
          </b-form-checkbox>


          <b-form-checkbox size="sm" v-model="workers.current.owner" value="1" unchecked-value="0" :disabled="disabled.owner">
            Владелец этого ИП
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.student" value="1" unchecked-value="0">
            Студент
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.mother" value="1" unchecked-value="0">
            Многодетная мать
          </b-form-checkbox>

          <hr>
          <h6>Вычеты по ИПН</h6>
          <b-form-checkbox size="sm" v-model="workers.current.recoupment" value="1" unchecked-value="0" :disabled="disabled.recoupment">
            Стандартный вычет по ИПН 14/30 МРП
          </b-form-checkbox>

          <b-form-select v-show="workers.current.recoupment == 1" size="sm" :options="[{value: '14', text: '14 МРП'},{value: '30', text: '30 МРП'}]" v-model="workers.current.recoupment_trigger"></b-form-select>


          <b-form-checkbox size="sm" v-model="workers.current.recoupment2" value="1" unchecked-value="0" :disabled="disabled.recoupment2">
            Стандартный вычет по ИПН 882 МРП
          </b-form-checkbox>

          <b-form-checkbox size="sm" v-model="workers.current.recoupment3" value="1" unchecked-value="0" :disabled="disabled.recoupment3">
            Стандартный вычет по ИПН 11.75/23.5 МРП
          </b-form-checkbox>

          <b-form-select v-show="workers.current.recoupment3 == 1" size="sm" :options="[{value: '23.5', text: '23.5 МРП'},{value: '11.75', text: '11.75 МРП'}]" v-model="workers.current.recoupment3_trigger"></b-form-select>



        </div>
        <div class="col-md-6">

          <div class="mb-3">
            <SelectGroup :title="'Подразделение'" v-model="workers.current.group_id"></SelectGroup>
          </div>

          <div role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="primary" size="sm">Начисления</b-button>
              </b-card-header>
              <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>

                    <div class="mb-3">
                      <div class="row">
                        <div :class="history.sum.list.length == 0 ? 'col-md-8' : 'col-md-11'">

                          <Enums :type="'local'" :name="'sums_primary'" :title="'Начисление'"
                                 v-model="workers.current.sum_type"></Enums>

                          <small class="text-muted form-text">Основное начисление *</small>
                        </div>
                        <div v-if="history.sum.list.length == 0" class="col-md-3">
                          <b-form-input size="sm" type="number" v-model="workers.current.sum"></b-form-input>
                        </div>
                        <div class="col-md-1">
                          <b-button v-if="workers.current.id" size="sm" variant="secondary" block @click="getSumHistory('sum')"><span class="mdi mdi-calendar-account"></span></b-button>
                        </div>
                      </div>
                      <div v-if="workers.current.sum_type !== 0 && history.sum.trigger" class="border shadow-sm p-2">
                        <h6>История значений для основного начисления</h6>
                        <div v-for="(item, index) in history.sum.list" :key="index" class="row mb-3">
                          <div class="col-md-6">
                            <Enums :type="'local'" :name="'sums_secondary'"
                                   v-model="item.type"></Enums>
                          </div>
                          <div class="col-3">
                            <b-form-input size="sm" type="date" v-model="item.date" />

                          </div>
                          <div class="col-2">
                            <b-form-input size="sm" type="number" v-model="item.sum_value" />
                          </div>
                          <div class="col-1">
                            <b-button size="sm" variant="danger" block @click="deleteSumHistory('sum', index)"><span class="mdi mdi-delete"></span></b-button>
                          </div>
                        </div>
                        <div class="text-right">
                          <b-button size="sm"  variant="secondary" class="mr-2" @click="addSumHistory('sum')">Добавить строку</b-button>
                          <b-button size="sm" variant="primary" @click="setSumHistory('sum')">Записать изменения</b-button>
                        </div>

                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div :class="history.sum1.list.length == 0 ? 'col-md-8' : 'col-md-11'">
                          <Enums :type="'local'" :name="'sums_secondary'" :title="'Начисление 1'"
                                 v-model="workers.current.sum1_type"></Enums>
                        </div>
                        <div v-if="history.sum1.list.length == 0" class="col-md-3">
                          <b-form-input  size="sm" type="number" v-model="workers.current.sum1"></b-form-input>
                        </div>
                        <div class="col-md-1">
                          <b-button v-if="workers.current.id" size="sm" variant="secondary" block @click="getSumHistory('sum1')"><span class="mdi mdi-calendar-account"></span></b-button>
                        </div>
                      </div>
                      <div v-if="workers.current.sum1_type !== 0 && history.sum1.trigger" class="border shadow-sm p-2">
                        <h6>История значений для начисления 1</h6>
                        <div v-for="(item, index) in history.sum1.list" :key="index" class="row mb-3">
                          <div class="col-6">
                            <b-input-group size="sm" prepend="Дата">
                              <b-form-input type="date" v-model="item.date" />
                            </b-input-group>
                          </div>
                          <div class="col-5">
                            <b-input-group size="sm" prepend="Сумма">
                              <b-form-input size="sm" type="number" v-model="item.sum_value" />
                            </b-input-group>
                          </div>
                          <div class="col-1">
                            <b-button size="sm" variant="danger" block @click="deleteSumHistory('sum1', index)"><span class="mdi mdi-delete"></span></b-button>
                          </div>
                        </div>
                        <div class="text-right">
                          <b-button size="sm"  variant="secondary" class="mr-2" @click="addSumHistory('sum1')">Добавить строку</b-button>
                          <b-button size="sm" variant="primary" @click="setSumHistory('sum1')">Записать изменения</b-button>
                        </div>

                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div :class="history.sum2.list.length == 0 ? 'col-md-8' : 'col-md-11'">
                          <Enums :type="'local'" :name="'sums_secondary'" :title="'Начисление 2'"
                                 v-model="workers.current.sum2_type"></Enums>
                        </div>
                        <div v-if="history.sum2.list.length == 0" class="col-md-3">
                          <b-form-input size="sm" type="number" v-model="workers.current.sum2"></b-form-input>
                        </div>
                        <div class="col-md-1">
                          <b-button v-if="workers.current.id" size="sm" variant="secondary" block @click="getSumHistory('sum2')"><span class="mdi mdi-calendar-account"></span></b-button>
                        </div>
                      </div>
                      <div v-if="workers.current.sum2_type !== 0 && history.sum2.trigger" class="border shadow-sm p-2">
                        <h6>История значений для начисления 2</h6>
                        <div v-for="(item, index) in history.sum2.list" :key="index" class="row mb-3">
                          <div class="col-6">
                            <b-input-group size="sm" prepend="Дата">
                              <b-form-input type="date" v-model="item.date" />
                            </b-input-group>
                          </div>
                          <div class="col-5">
                            <b-input-group size="sm" prepend="Сумма">
                              <b-form-input size="sm" type="number" v-model="item.sum_value" />
                            </b-input-group>
                          </div>
                          <div class="col-1">
                            <b-button size="sm" variant="danger" block @click="deleteSumHistory('sum2', index)"><span class="mdi mdi-delete"></span></b-button>
                          </div>
                        </div>
                        <div class="text-right">
                          <b-button size="sm"  variant="secondary" class="mr-2" @click="addSumHistory('sum2')">Добавить строку</b-button>
                          <b-button size="sm" variant="primary" @click="setSumHistory('sum2')">Записать изменения</b-button>
                        </div>

                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div :class="history.sum3.list.length == 0 ? 'col-md-8' : 'col-md-11'">
                          <Enums :type="'local'" :name="'sums_secondary'" :title="'Начисление 3'"
                                 v-model="workers.current.sum3_type"></Enums>
                        </div>
                        <div v-if="history.sum3.list.length == 0" class="col-md-3">
                          <b-form-input size="sm" type="number" v-model="workers.current.sum3"></b-form-input>
                        </div>
                        <div class="col-md-1">
                          <b-button v-if="workers.current.id" size="sm" variant="secondary" block @click="getSumHistory('sum3')"><span class="mdi mdi-calendar-account"></span></b-button>
                        </div>
                      </div>
                      <div v-if="workers.current.sum3_type !== 0 && history.sum3.trigger" class="border shadow-sm p-2">
                        <h6>История значений для начисления 3</h6>
                        <div v-for="(item, index) in history.sum3.list" :key="index" class="row mb-3">
                          <div class="col-6">
                            <b-input-group size="sm" prepend="Дата">
                              <b-form-input type="date" v-model="item.date" />
                            </b-input-group>
                          </div>
                          <div class="col-5">
                            <b-input-group size="sm" prepend="Сумма">
                              <b-form-input size="sm" type="number" v-model="item.sum_value" />
                            </b-input-group>
                          </div>
                          <div class="col-1">
                            <b-button size="sm" variant="danger" block @click="deleteSumHistory('sum3', index)"><span class="mdi mdi-delete"></span></b-button>
                          </div>
                        </div>
                        <div class="text-right">
                          <b-button size="sm"  variant="secondary" class="mr-2" @click="addSumHistory('sum3')">Добавить строку</b-button>
                          <b-button size="sm" variant="primary" @click="setSumHistory('sum3')">Записать изменения</b-button>
                        </div>

                      </div>
                    </div>

                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="primary" size="sm">Удержания</b-button>
              </b-card-header>
              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-md-9">
                          <Enums :type="'local'" :name="'deductions'" :title="'Удержание 1'"
                                 v-model="workers.current.deduction_type"></Enums>
                        </div>
                        <div class="col-md-3">
                          <b-form-input size="sm" type="number"
                                        v-model="workers.current.deduction"></b-form-input>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-md-9">
                          <Enums :type="'local'" :name="'deductions'" :title="'Удержание 2'"
                                 v-model="workers.current.deduction1_type"></Enums>
                        </div>
                        <div class="col-md-3">
                          <b-form-input size="sm" type="number"
                                        v-model="workers.current.deduction1"></b-form-input>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-md-9">
                          <Enums :type="'local'" :name="'deductions'" :title="'Удержание 3'"
                                 v-model="workers.current.deduction2_type"></Enums>
                        </div>
                        <div class="col-md-3">
                          <b-form-input size="sm" type="number"
                                        v-model="workers.current.deduction2"></b-form-input>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-md-9">
                          <Enums :type="'local'" :name="'deductions'" :title="'Удержание 4'"
                                 v-model="workers.current.deduction3_type"></Enums>
                        </div>
                        <div class="col-md-3">
                          <b-form-input size="sm" type="number"
                                        v-model="workers.current.deduction3"></b-form-input>
                        </div>
                      </div>
                    </div>

                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>


          </div>


          <hr>

          <h6>Карточный счет</h6>
          <div class="row">
            <div class="col-md-7">
              <Enums :type="'local'" :name="'banks'"
                     v-model="workers.current.bank_id"></Enums>
              <small class="text-muted form-text">Банк, который обслуживает счет</small>

            </div>
            <div class="col-md-5">
              <b-form-input size="sm" type="text" v-model="workers.current.iik"></b-form-input>
              <small class="text-muted form-text">20-значный номер счета</small>
            </div>
          </div>

          <hr>
          <h6>Резиденство (для формирования SWIFT)</h6>
          <div class="row">
            <div class="col-md-8">
              <Enums :type="'local'" :name="'countries'"
                     v-model="workers.current.country_id"></Enums>
              <small class="text-muted form-text">Страна резиденства</small>

            </div>
            <div class="col-md-4">
              <b-form-input size="sm" type="text" v-model="workers.current.kbe"></b-form-input>
              <small class="text-muted form-text">Код Бенефициара. 19 - резидент, 29 - нерезидент</small>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <b-textarea rows="5" size="sm" v-model="workers.current.notes" placeholder="Заметки"></b-textarea>
              </div>
            </div>
          </div>


        </div>
      </div>

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="primary" size="sm" @click="regWorkers('save')"><span class="mdi mdi-content-save"></span> Сохранить
        </b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
        </b-button>
      </template>
    </b-modal>

    <b-modal header-bg-variant="primary" header-text-variant="white" v-if="typeof workers.current != 'undefined'" size="lg" id="modal-workers-copy" centered ok-disabled
             title="Копирование/перемещение данных сотрудника" cancel-title-html="Закрыть" button-size="sm">

      <div class="row">
        <div class="col-12">
          <p>Вы можете переместить сотрудника полностью со всеми его расчетами или просто дублировать данные сотрудника в другую организацию из вашего стравочника</p>
          <p>Обратите внимание на то, что при копировании дублируются только данные сотрудника из справочника сотрудников, а при перемещении переносятся все расчеты сотрудника, если они у него есть.</p>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Выберите организацию</label>
            <b-form-select size="sm" :options="orgsWithoutCurrent()" v-model="params.org_for_copy"></b-form-select>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="primary" size="sm" @click="regWorkers('do_copy_worker', workers.current.id)"><span class="mdi mdi-content-copy"></span> Копировать
        </b-button>
        <b-button variant="primary" size="sm" @click="regWorkers('do_move_worker', workers.current.id)"><span class="mdi mdi-chevron-double-right"></span> Переместить
        </b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
        </b-button>
      </template>
    </b-modal>


    <Register :showorg="true" :params="this.params" :register="this.workers" :links="links" @change="regWorkers"></Register>
  </div>


</template>


<script>

import Register from "@/components/base/Register";
import Enums from "@/components/base/Enums";
import SelectGroup from "@/components/base/SelectGroup";
import {mapGetters} from "vuex";

export default {
  name: 'Workers',
  components: {
    Register,
    Enums,
    SelectGroup
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (event, id) => {
      event;
      if (id == 'modal-workers') {
        this.regWorkers();
      }

    })
  },
  data: function () {
    return {
      links: [
        {name: 'Справочник организаций', link: '/registers/organizations/', icon: 'mdi mdi-domain'},
        {name: 'Справочник подразделений', link: '/registers/groups/', icon: 'mdi mdi-home-group'},
      ],
      params: {
        name: 'workers',
        title: 'Сотрудники',
        icon: 'mdi mdi-account-group',
        table: 'reg_workers',
        order: ' ORDER BY last_name ASC, first_name ASC, middle_name ASC ',
        addnew: 'Добавить нового сотрудника',
        org: true,
        org_for_copy: 0,
        fields: [
          {name: 'ID', model: 'id', type: 'int'},
          {name: 'Подразделение', model: 'group_id', type: 'int', required: false, default: 0, print: false},
          {name: 'Табельный номер', model: 'employee_number', type: 'string', required: false, show: true, print: true},
          {name: 'Фамилия', model: 'last_name', type: 'string', required: true, show: true, print: true},
          {name: 'Имя', model: 'first_name', type: 'string', required: true, show: true, print: true},
          {name: 'Отчество', model: 'middle_name', type: 'string', required: false, show: true, print: true},
          {name: 'ИИН', model: 'iin', type: 'string', required: false, min: 12, max: 12, show: true, print: true},
          {name: 'Дата рождения', model: 'birthday', type: 'date', required: true, default: '1980-01-01', print: true},
          {name: 'Пол', model: 'gender', type: 'int', required: false, default: 0, print: true},
          {name: 'Должность', model: 'workerfunction', type: 'string', required: false, default: '', print: true},
          {name: 'Владелец этого ИП', model: 'owner', type: 'bool', required: false, default: 0, print: false},

          {name: 'Инвалидность', model: 'invalid_group', type: 'int', required: false, default: 0},
          {name: 'Гражданин РК', model: 'citizen', type: 'bool', required: false, default: 1},
          {name: 'Вид на жительство', model: 'residence_permit', type: 'bool', required: false, default: 1},
          {name: 'Резидент', model: 'resident', type: 'bool', required: false, default: 1},
          {name: 'Иностранец-резидент', model: 'foreigner_resident', type: 'bool', required: false, default: 0},
          {name: 'Член ЕАЭС', model: 'eaes_member', type: 'bool', required: false, default: 1},
          {name: 'Нерезидент дистанционник', model: 'remote_worker', type: 'bool', required: false, default: 0},
          {name: 'Пенсионер', model: 'pensioner', type: 'bool', required: false, default: 0},
          {name: 'Пенсионер по возрасту', model: 'pensioner_year', type: 'bool', required: false, default: 0},
          {name: 'Вредные условия труда (ОППВ)', model: 'harmful_working_conditions', type: 'bool', required: false, default: 0},
          {name: 'Основное место работы', model: 'main_work', type: 'bool', required: false, default: 1},
          {name: 'Договор ГПХ', model: 'civil_contract', type: 'bool', required: false, default: 0},
          {name: 'Стандартный вычет по ИПН 14/30 МРП', model: 'recoupment', type: 'bool', required: false, default: 1},
          {name: '14 или 30 МРП', model: 'recoupment_trigger', type: 'string', required: false, default: '14'},
          {name: 'Стандартный вычет по ИПН 882 МРП', model: 'recoupment2', type: 'bool', required: false, default: 0},
          {name: 'Стандартный вычет по ИПН 11.75/23.5 МРП', model: 'recoupment3', type: 'bool', required: false, default: 0},
          {name: '11.75 или 23.5 МРП', model: 'recoupment3_trigger', type: 'string', required: false, default: '23.5'},
          {name: 'Студент', model: 'student', type: 'bool', required: false, default: 0},
          {name: 'Ветеран боевых действий', model: 'warrior', type: 'bool', required: false, default: 0},
          {name: 'Ликвидатор последствий аварии на ЧАЭС', model: 'chernobyl', type: 'bool', required: false, default: 0},
          {name: 'Многодетная мать', model: 'mother', type: 'bool', required: false, default: 0},

          {name: 'Основное начисление', model: 'sum', type: 'float', required: true, default: 0},
          {name: 'Тип начисления', model: 'sum_type', type: 'int', required: true, default: 0},
          {name: 'Начисление 1', model: 'sum1', type: 'float', required: false, default: 0},
          {name: 'Тип начисления 1', model: 'sum1_type', type: 'int', required: false, default: 0},
          {name: 'Начисление 2', model: 'sum2', type: 'float', required: false, default: 0},
          {name: 'Тип начисления 2', model: 'sum2_type', type: 'int', required: false, default: 0},
          {name: 'Начисление 3', model: 'sum3', type: 'float', required: false, default: 0},
          {name: 'Тип начисления 3', model: 'sum3_type', type: 'int', required: false, default: 0},


          {name: 'Удержание', model: 'deduction', type: 'float', required: false, default: 0},
          {name: 'Тип удержания', model: 'deduction_type', type: 'int', required: false, default: 0},
          {name: 'Удержание 1', model: 'deduction1', type: 'float', required: false, default: 0},
          {name: 'Тип удержания 1', model: 'deduction1_type', type: 'int', required: false, default: 0},
          {name: 'Удержание 2', model: 'deduction2', type: 'float', required: false, default: 0},
          {name: 'Тип удержания 2', model: 'deduction2_type', type: 'int', required: false, default: 0},
          {name: 'Удержание 3', model: 'deduction3', type: 'float', required: false, default: 0},
          {name: 'Тип удержания 3', model: 'deduction3_type', type: 'int', required: false, default: 0},

          {name: 'Банк', model: 'bank_id', type: 'int', required: false, default: 0},
          {name: 'ИИК', model: 'iik', type: 'string', required: false, print: true},
          {name: 'КБе', model: 'kbe', type: 'string', required: true, print: false},
          {name: 'Страна резидентства', model: 'country_id', type: 'int', required: false, default: 0},
          {name: 'Заметки', model: 'notes', type: 'string', required: false, print: false}

        ],
        task: ['edit', 'delete', 'copy_worker', 'select'],
        select: ['last_name', 'first_name', 'middle_name']
      },
      disabled: {
        resident: false,
        residence_permit: false,
        foreigner_resident: false,
        eaes_member: false,
        remote_worker: false,
        recoupment: false,
        owner: false
      },
      history: {
        sum: {
          trigger: false,
          list: []
        },
        sum1: {
          trigger: false,
          list: []
        },
        sum2: {
          trigger: false,
          list: []
        },
        sum3: {
          trigger: false,
          list: []
        },
      }
    }
  },
  methods: {
    deleteSumHistory: function (field, index) {
      this.history[field].list.splice(index, 1)
    },
    addSumHistory: function (field) {
      this.history[field].list.push({type: 0, field: field, date: '', sum_value: 0})
    },
    setSumHistory: function (field) {
      this.$store.commit('wait', {state: true, name: 'Сохранение истории начислений'});
      this.$http
          .post(this.$apiold, {
            task: 'set-sum-history',
            worker_id: this.workers.current.id,
            type: this.workers.current[field + '_type'],
            field: field,
            list: this.history[field].list
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('alert', response.data.messages);

          })
    },
    getSumHistory: function (field) {
      this.$store.commit('wait', {state: true, name: 'Загрузка истории начислений'});
      this.$http
          .post(this.$apiold, {
            task: 'get-sum-history',
            type: this.workers.current[field + '_type'],
            worker_id: this.workers.current.id,
            field: field
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.history[field].trigger = true
            this.history[field].list = response.data.result

          })
    },
    orgsWithoutCurrent: function () {
      let orgsWC = [];
      orgsWC.push({text: 'Организация не выбрана', value: 0})
      this.orgs.list.forEach((item) => {
        if (item.id !== this.orgs.current.id) {
          orgsWC.push({text: item.name, value: item.id})
        }
      })
      return orgsWC
    },
    regWorkers: function (mode, id) {

      // Преобразуем суммы в числа, если это не так
      this.workers.current.sum == ''  ? this.workers.current.sum = 0 : null
      this.workers.current.sum1 == ''  ? this.workers.current.sum1 = 0 : null
      this.workers.current.sum2 == ''  ? this.workers.current.sum2 = 0 : null
      this.workers.current.sum3 == ''  ? this.workers.current.sum3 = 0 : null
      this.workers.current.deduction == ''  ? this.workers.current.deduction = 0 : null
      this.workers.current.deduction1 == ''  ? this.workers.current.deduction1 = 0 : null
      this.workers.current.deduction2 == ''  ? this.workers.current.deduction2 = 0 : null
      this.workers.current.deduction3 == ''  ? this.workers.current.deduction3 = 0 : null


      this.$store.commit('wait', {state: true, name: 'Справочник сотрудников'});
      this.$http
          .post(this.$apiold, {
            task: 'list',
            mode: mode,
            id: id,
            orgid: this.orgs.current.id,
            params: this.params,
            data: this.workers.current
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.$store.commit('regChange', {name: this.params.name, register: response.data.register});

            if (response.data.modal) {
              this.$bvModal.show('modal-workers');
            } else {
              this.$bvModal.hide('modal-workers');
            }

            // Открываем окно копирования/перемещения сотрудника
            if (response.data.modal_copy) {
              this.$bvModal.show('modal-workers-copy');
            } else {
              this.$bvModal.hide('modal-workers-copy');
            }

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    },
    Params: function () {
      if (!this.params_blocker) {
        //this.params_blocker = true;
        this.$store.commit('wait', {state: true, name: 'Обработка параметров для расчета зарплаты'});
        this.show_result = false;

        this.$http
            .post(this.$apiold, {
              task: 'salary-params',
              worker: this.workers.current,
              org: this.orgs.current
            })
            .then(response => {
              this.$store.commit('wait', {state: false});
              this.$store.commit('user', response.data.user);

              var result = response.data.result;
              this.disabled = result.disabled;


            });
      }
    }

  },
  created: function () {
    this.$store.commit('change');
  },
  computed: {
    ...mapGetters({
      changed: 'changed',
      orgs: 'orgs',
      workers: 'workers',
      groups: 'groups'
    })
  },
  watch: {
    orgs() {
      this.regWorkers();
    },

    workers: {
      handler: function () {
        if (typeof this.workers !== 'undefined' && this.workers.current.iin.length == 12) {
          // Сюда вставить автоматическое проставление даты рождения на основании ИИН
          //let iinYear = this.workers.current.iin.substring(0, 2)
          //let iinMonth = this.workers.current.iin.substring(2, 4)
          //let iinDay = this.workers.current.iin.substring(4, 6)


          //let iinAge = '00'
          //this.workers.current.iin.substring(6,7) == '1' || this.workers.current.iin.substring(6,7) == '2' ? iinAge = '18' : null
          //this.workers.current.iin.substring(6,7) == '3' || this.workers.current.iin.substring(6,7) == '4' ? iinAge = '19' : null
          //this.workers.current.iin.substring(6,7) == '5' || this.workers.current.iin.substring(6,7) == '6' ? iinAge = '20' : null

          //let iinDate = iinAge + iinYear + '-' + iinMonth + '-' + iinDay
          //if (this.workers.current.iin.substring(6,7) !== '0') {
            //this.workers.current.birthday = iinDate
          //}

          this.workers.current.iin.substring(6,7) == '1' || this.workers.current.iin.substring(6,7) == '3' || this.workers.current.iin.substring(6,7) == '5' ? this.workers.current.gender = 1 : null
          this.workers.current.iin.substring(6,7) == '2' || this.workers.current.iin.substring(6,7) == '4' || this.workers.current.iin.substring(6,7) == '6' ? this.workers.current.gender = 2 : null

        }
        //this.Params();




      },
      deep: true
    },
    changed() {
      this.regWorkers();
    },
  }
}
</script>


<style>

</style>
